import { render } from "./CompactMenu.vue?vue&type=template&id=b3955b4e&scoped=true"
import script from "./CompactMenu.vue?vue&type=script&lang=js"
export * from "./CompactMenu.vue?vue&type=script&lang=js"

import "./CompactMenu.vue?vue&type=style&index=0&id=b3955b4e&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3955b4e"]])

export default __exports__